<script setup lang="ts">
import { useModelMqtt } from './../model/model'
import { computed, type PropType, ref, watchEffect } from 'vue'
import { useSendMqtt } from './../model/api'

const props = defineProps({
  serial: {
    type: String,
    required: true,
  },
  brokers: {
    type: Array as PropType<any[]>,
    required: true,
  },
})

const { messageTypes, data, logTypes } = useModelMqtt()

/**
 * Вычисляем topic для команд
 */
const topicPrepend = computed(() => {
  switch (data.value.topic_type) {
    case 'custom':
      return `controllers/${props.serial}/in/`
  }
})

/**
 * Устанавливаем значения по умолчанию в
 * зависимости от типа
 */
watchEffect(() => {
  switch (data.value.topic_type) {
    case 'system_log':
      data.value.message = 'indigo.log.0'
      break
    case 'change_broker':
      data.value.message = 1
      break
    default:
      data.value.message = ''
  }
})

const valid = ref(false)
const { sendForm, isPending } = useSendMqtt()
</script>

<template>
  <VForm v-model="valid" @submit.prevent="sendForm(data, valid)">
    <div class="form__grid_3">
      <VSelect
        :label="$t('itf.select_message_type')"
        :items="messageTypes"
        v-model="data.topic_type"
        :item-title="(item) => $t(`itf.admin_services.${item}`)"
        :item-value="(item) => item"
      />

      <template v-if="data.topic_type === 'custom'">
        <VTextField :label="$t('itf.topic')" v-model="data.topic">
          <template #prepend-inner>{{ topicPrepend }}</template>
        </VTextField>

        <VTextField :label="$t('itf.message')" v-model="data.message" />
      </template>

      <template v-if="data.topic_type === 'system_log'">
        <VSelect
          :label="$t('itf.admin_services.system_log')"
          v-model="data.message"
          :items="logTypes"
        />
      </template>

      <template v-if="data.topic_type === 'change_broker'">
        <VSelect
          :label="$t('itf.mqtt_broker')"
          v-model="data.message"
          :items="brokers"
          item-title="broker_name"
          item-value="id"
        />
      </template>

      <template v-if="['at_commands', 'rs-485'].includes(data.topic_type)">
        <VTextField :label="$t('itf.message')" v-model="data.message" />
      </template>
    </div>

    <VBtn type="submit" :loading="isPending">{{ $t('itf.submit') }}</VBtn>
  </VForm>
</template>
